import { render, staticRenderFns } from "./HomepageArticles.vue?vue&type=template&id=44038db4&scoped=true&"
import script from "./HomepageArticles.vue?vue&type=script&lang=ts&"
export * from "./HomepageArticles.vue?vue&type=script&lang=ts&"
import style0 from "./HomepageArticles.vue?vue&type=style&index=0&id=44038db4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44038db4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomepageArticle: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/homepage/HomepageArticle.vue').default})
